// use-query.ts
import { Observable } from "rxjs";
import { _useMemo, getCurrentComponent } from "./stateful.js";
var useQuery = (source, deps) => {
  if (!deps) {
    throw new Error("useQuery requires deps array to prevent excessive renders");
  }
  return _useMemo((hook) => {
    const component = getCurrentComponent();
    const initialState = {
      loading: true,
      value: void 0,
      error: null
    };
    let immediateRender = true;
    hook.value = initialState;
    const updateState = (newState) => {
      hook.value = { ...hook.value, ...newState };
      if (!immediateRender)
        component.instance.rerender();
    };
    const sourceResolved = source();
    let cleanup;
    if (sourceResolved instanceof Observable) {
      const subscription = sourceResolved.subscribe({
        next: (value) => updateState({ loading: false, value, error: null }),
        error: (error) => updateState({ loading: false, value: null, error }),
        complete: () => updateState({ loading: false })
      });
      cleanup = () => subscription.unsubscribe();
    } else if (sourceResolved instanceof Promise) {
      let disposed = false;
      sourceResolved.then((value) => {
        if (disposed)
          return;
        updateState({ loading: false, value, error: null });
      }).catch((error) => {
        if (disposed)
          return;
        updateState({ loading: false, value: null, error });
      });
      cleanup = () => disposed = true;
    }
    immediateRender = false;
    return [hook.value, cleanup ?? (() => {
    })];
  }, deps).value;
};
export {
  useQuery
};
